export default __webpack_public_path__ + "static/media/ISRO_Project_Report.ca90637b.pdf";